import emailjs from "@emailjs/browser";

const config = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
};

emailjs.init({ publicKey: config.publicKey, limitRate: { id: "mmgt-forms", throttle: 5000 } });

// Variable names must match the EmailJS dashboard template exactly:
// {{name}} {{company}} {{phone}} {{email}} {{service}} {{message}} {{time}} {{from_name}}
export async function sendInquiryEmail({ name, company, phone, email, service, message }) {
  const params = {
    from_name: (name || "Website Visitor").trim(),
    name: (name || "").trim(),
    company: (company || "—").trim(),
    phone: (phone || "").trim(),
    email: (email || "—").trim(),
    service: service || "—",
    message: (message || "—").trim(),
    time: new Date().toLocaleString("en-AE", { timeZone: "Asia/Dubai" }),
  };
  return emailjs.send(config.serviceId, config.templateId, params, { publicKey: config.publicKey });
}

// Careers template variables: {{title}} {{name}} {{phone}} {{email}} {{license}} {{experience}} {{message}} {{cv_link}} {{cv_filename}} {{time}}
export async function sendApplicationEmail({ name, phone, email, license, experience, message, cv_link, cv_filename }) {
  const serviceId = process.env.REACT_APP_EMAILJS_CAREERS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_CAREERS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_CAREERS_PUBLIC_KEY;
  if (!serviceId || !templateId || !publicKey) return null;
  const params = {
    title: (name || "Careers Applicant").trim(),
    name: (name || "").trim(),
    phone: (phone || "").trim(),
    email: (email || "").trim(),
    license: (license || "").trim(),
    experience: (experience || "").trim(),
    message: (message || "—").trim(),
    cv_link: cv_link || "—",
    cv_filename: cv_filename || "—",
    time: new Date().toLocaleString("en-AE", { timeZone: "Asia/Dubai" }),
  };
  return emailjs.send(serviceId, templateId, params, { publicKey });
}
